import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Button, Text } from 'components/UI';
import { useUser } from 'contexts';
import { bodyFont } from 'constants/theme';
import { removeStorageItem } from 'utils/helpers';
import AppRoutes from 'constants/routes';

const LoggedInMessage = () => {
  const [, setUser] = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    setUser(undefined);
    removeStorageItem('variant-token');

    navigate(AppRoutes.ForgotPassword);
  };

  return (
    <Box my={4}>
      <Text textAlign="center">You are currently logged in.</Text>
      <Text display="flex" alignItems="center" justifyContent="center">
        Please click&nbsp;
        <Button
          variant="unstyled"
          onClick={handleLogout}
          sx={{
            h: 'auto',
            letterSpacing: 'normal',
            p: 0,
            color: 'primaryThemeColour.400',
            _focus: {
              boxShadow: 'none',
            },
            textDecoration: 'underline',
            fontFamily: bodyFont,
            fontSize: 'md',
            width: 'auto',
            minWidth: 'auto',
          }}
        >
          here
        </Button>
        &nbsp;to logout and reset your password.
      </Text>
    </Box>
  );
};

export default LoggedInMessage;
